import { render, staticRenderFns } from "./integrated.vue?vue&type=template&id=0ff359d9&scoped=true&"
import script from "./integrated.vue?vue&type=script&lang=js&"
export * from "./integrated.vue?vue&type=script&lang=js&"
import style0 from "./integrated.vue?vue&type=style&index=0&id=0ff359d9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff359d9",
  null
  
)

export default component.exports